import { onCleanup, onMount } from 'solid-js';

const TEXT_ENTRY_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

const isTextEntryElement = (el: Element | null): el is HTMLElement =>
  el !== null &&
  (TEXT_ENTRY_TAGS.includes(el.tagName) ||
    (el as HTMLElement).isContentEditable);

type OptionsT = {
  isOpen: () => boolean;
  isBlocked?: () => boolean;
  onEscape: () => void;
};

export const createEscapeToClose = (options: OptionsT) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (
      event.key !== 'Escape' ||
      event.defaultPrevented ||
      !options.isOpen() ||
      options.isBlocked?.() === true
    ) {
      return;
    }

    const activeElement = document.activeElement;

    if (isTextEntryElement(activeElement)) {
      activeElement.blur();
      return;
    }

    options.onEscape();
  };

  onMount(() => {
    document.addEventListener('keydown', handleKeyDown);
  });

  onCleanup(() => {
    document.removeEventListener('keydown', handleKeyDown);
  });
};
